export default __webpack_public_path__ + "static/media/pin.9379fc07.svg";